module.exports = __webpack_public_path__ + "cf1ab4c3d8ed526840d4f5d94f1febf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gplay.png
// module id = 746
// module chunks = 0